// extracted by mini-css-extract-plugin
export var container = "footer-module--container--3anUK";
export var left_txt = "footer-module--left_txt--3J-1O";
export var link = "footer-module--link--2tGs2";